export default __webpack_public_path__ + "775e5863912923db0ecd1e3f3554963e.svg";